import AdminPhaseRequests from './AdminPhaseRequests';
export default function AdminPhase2Requests() {
  return <AdminPhaseRequests target="phase_2" title="Phase 2 Requests" subtitle="Core and Global programs requesting upgrade from Phase 1 to Phase 2." />;
}
